<template lang="html">
  <div class="sub-main column">
		<div class="sub-page column">
			  <section class="take-place column activity-container container-background">
					<div class='header-table row'>
						<div class='title'>
							Clients
						</div>
						<div class="attached-item row">
							<div class="phantom-flex"></div>
							<div class="ctn-cta">
								<div class="btn btn-red" @click="showAddClient = true">
									<span class="icon-form-plus"></span> Ajouter un client
								</div>
							</div>
						</div>
					</div>
					<Table :elements="clients" :clickable="true" @statuschange="updateStatus" />
					<baseModal :show="showAddClient" @close="showAddClient = false" :content="contentModal" />
  			</section>
		</div>
  </div>
</template>

<style lang="scss">
</style>

<script>
import store from '@/store'
import {mapGetters} from 'vuex'
import ModalAddClient from './modals/ClientModal'
import baseModal from '@/common/components/baseModal'
import Table from './ClientsTable'

export default {
	name: 'Clients',
	components: {
		Table,
		baseModal
	},
	data () {
		return {
			showAddClient: false,
			contentModal: ModalAddClient
		}
	},
	beforeRouteEnter (to, from, next) {
		store.commit('LOADER_IN')
    store.dispatch('getClients')
    .then(() => {
			next()
    })
    .catch(() => {
			next(false)
    })
    .finally(() => {
			store.commit('LOADER_OUT')
    })
	},
	methods: {
		updateStatus (e) {
      const {value, rowIndex} = e
      const id = this.clients[rowIndex].id
      const enable = !value
      store.commit('LOADER_IN')
      if (enable) {
        this.$store.dispatch('enableClient', id)
        .finally(() => {
          store.commit('LOADER_OUT')
        })
      } else {
        this.$store.dispatch('disableClient', id)
        .finally(() => {
          store.commit('LOADER_OUT')
        })
      }
		}
	},
	computed: {
		...mapGetters({
			clients: 'clients'
		})
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?6dc0991e